import styled from 'styled-components';
import { colorAppBorder } from 'common/styles/colors';
import { baseBorderWidth, containerPaddingS, containerPaddingM } from 'common/styles/variables';

const SectionSeparator = styled.div`
    margin-top: ${containerPaddingM};
    margin-bottom: ${containerPaddingS};
    border-bottom: ${baseBorderWidth} solid ${colorAppBorder};
    width: 100%;
    height: 0;
`;

export default SectionSeparator;
